import { makeStyles } from '@material-ui/core';

//NOSONAR TODO: CDS-676 update backgroundColor with theme.pallete
export const useStyles = ({ variant, wrap = true }) =>
  makeStyles((theme) => {
    const colors = {
      info: {
        light: '#F5F7FC',
        dark: '#0274B6',
      },
      success: {
        light: '#F5FAF5',
        dark: '#2B8000',
      },
      warning: {
        light: '#FCF8F3',
        dark: '#BD4F00',
        darkest: '#8A4C00',
      },
      error: {
        dark: '#D9221C',
        light: '#FDF7F6',
      },
    };

    return {
      customNotification: {
        border: `1px solid ${colors[variant].dark} `,
        borderRadius: '6px',
        backgroundColor: colors[variant].light,
        padding: '18px',
        paddingBottom: wrap ? theme.spacing(3) : '18px',
        zIndex: 0,
        display: 'flex',
        margin: `${theme.spacing(3)} 0`,
      },
      icon: {
        width: theme.spacing(2.5),
        height: theme.spacing(2.5),
        overflow: 'visible',
        '& svg': {
          fill: colors[variant].dark,
        },
      },
      content: {
        marginLeft: '18px',
        display: 'flex',
        flexDirection: wrap ? 'column' : 'row',
        flexGrow: 1,
        gap: theme.spacing(1),
        alignItems: wrap ? 'flex-start' : 'center',
        height: wrap ? 'auto' : '16px',
        '& > *': {
          marginTop: 0,
          marginBottom: 0,
          lineHeight: wrap ? 'auto' : '16px',
          height: wrap ? 'auto' : '16px',
        },
      },
      title: {
        color: colors[variant].dark,
      },
      description: {
        color: colors[variant].dark,
      },
      linkButton: {
        color: colors[variant].dark,
        textDecoration: 'underline',
        cursor: 'pointer',
        '&:hover': {
          color: colors[variant].darkest,
        },
      },
    };
  })();

export const useNotificationStyles = makeStyles((theme) => ({
  notificationsContainer: {
    position: 'fixed',
    left: 0,
    paddingLeft: '256px',
    width: '100%',
    zIndex: 1,
    flex: '1 0 0',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },
  notification: {
    margin: '0px 30px',
    '&:not(:last-child)': {
      marginBottom: '15px',
    },
    '& p': {
      [theme.breakpoints.down('sm')]: {
        whiteSpace: 'wrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
  },
}));
